module.exports = __webpack_public_path__ + "img/more-functions.58c0c52b.png";